import { BIDDING_CONFIGURATION } from 'constants/endpoints';
import { METHOD_PATCH } from 'requests';
import { ApiRequestConfigType } from 'requests/index.types';

interface IBiddingConfigurationPayload {
  employment_statuses: string[];
  bidding_overtime_default?: boolean;
}

export const API_PATCH_biddingConfiguration = (
  communityId: string,
  payload: IBiddingConfigurationPayload,
): ApiRequestConfigType => {
  return {
    __typename: 'LegacyAPI',
    method: METHOD_PATCH,
    url: BIDDING_CONFIGURATION(communityId),
    body: {
      bidding_configuration: {
        conflict_employment_statuses: payload.employment_statuses,
        ...(payload.bidding_overtime_default !== undefined && {
          bidding_overtime_default: payload.bidding_overtime_default,
        }),
      },
    },
  };
};
